import React, { useState } from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { WhatsButton } from '../../components';
import './infos.css';

import { tituloInfo1, tituloInfo2, tituloInfo3, tituloInfo4, tituloInfo5, tituloInfo6 } from './infos-titulos';
import { textoInfo1, textoInfo2, textoInfo3, textoInfo4, textoInfo5, textoInfo6 } from './infos-textos';

import { Info } from '../../components';

const Infos = () => {
  const [expandedInfoIndex, setExpandedInfoIndex] = useState(null);
  const titulos = [tituloInfo1, tituloInfo2, tituloInfo3, tituloInfo4, tituloInfo5, tituloInfo6];
  const textos = [textoInfo1, textoInfo2, textoInfo3, textoInfo4, textoInfo5, textoInfo6];

  const handleInfoClick = (index) => {
    if (index === expandedInfoIndex) {
      setExpandedInfoIndex(null);
    } else {
      setExpandedInfoIndex(index);
    }
  };

  return (
    <div className="psico__infos section__padding" id="infos">
      <div className="psico__infos-title">
        <AnimationOnScroll animateIn="slide-in-left" duration={2.5}>
          <h2>Como Funciona a Psicoterapia?</h2>
        </AnimationOnScroll>
      </div>

      {/* <div className="psico__infos-title-broken">
        <AnimationOnScroll animateIn="slide-in-left" duration={1}>
          <h2>Como Funciona a</h2>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="slide-in-left" duration={1} delay={1000}>
          <h2>Psicoterapia</h2>
        </AnimationOnScroll>
      </div> */}


      <div className="psico__infos-content">

        {titulos.map((titulo, index) => (
          <AnimationOnScroll key={index} animateIn="slide-in-left" duration={1.5}>
            <Info
              titulo={titulo}
              texto={textos[index]}
              expanded={index === expandedInfoIndex}
              onClick={() => handleInfoClick(index)}
            />
          </AnimationOnScroll>
        ))}

      </div>

      <AnimationOnScroll animateIn="fade-in-bottom" duration={0.75}>
        <div className="psico__infos-mais">
          <div className="psico__infos-mais__content">
            <p>Precisa de mais informações?</p>
            {/* <p></p> */}
          </div>
          <div className="psico__infos-mais__button">
            <WhatsButton message="Entre em contato!" />
          </div>
        </div>
      </AnimationOnScroll>

    </div>
  );
};

export default Infos;
